<template>
  <div class="hero min-h-screen">
    <div class="hero min-h-screen" :style="{ backgroundImage: 'url(' + home.background + ')' }" v-if="home.title">
      <div class="hero-overlay bg-opacity-60"></div>
      <div class="hero-content text-center text-neutral-content">
        <div class="max-w-md">
          <h1 class="mb-5 text-3xl md:text-5xl text-white font-bold">{{ home.title }}</h1>
          <p class="mb-5 text-white" v-html="home.description"></p>
          <router-link class="btn btn-primary" :to="{ name: 'login' }">
            <ArrowRightOnRectangleIcon class="w-5 h-5 ml-2" /> {{ __('Log in and register') }}
          </router-link>
        </div>
      </div>
    </div>
    <Progressbar v-else />
  </div>
</template>
<script setup>

import useHome from '../../../composables/shop/home'
import { onMounted, reactive } from "vue";
import { ArrowRightOnRectangleIcon } from '@heroicons/vue/24/outline';
const { home, getHome } = useHome();
onMounted(() => getHome());

</script>